import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AtCentralizers, AtMiddlePoint, LateralLoadResults, StandOffCalcService, WellGeometry, SharedSettingsService } from '../../services/rheological.service';

@Component({
    selector: 'app-standoff-calculator',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './standoff-calculator.component.html',
    styleUrl: './standoff-calculator.component.css',
})
export class StandoffCalculatorComponent implements OnInit, OnDestroy {

    wellGeometry: WellGeometry = {};
    atMiddlePoint: AtMiddlePoint = {};
    atCentralizers: AtCentralizers = {};
    lateralLoadResults: LateralLoadResults = {};

    private subscription: Subscription | null = null;

    constructor(
        private sharedSettingsService: SharedSettingsService,
        private standOffService: StandOffCalcService
    ) {}

    ngOnInit(): void {
        this.wellGeometry.casingWeight = null;
        this.wellGeometry.casingOD = 9.625;
        this.wellGeometry.casingID = null;
        this.wellGeometry.connectionOD = null;
        this.wellGeometry.holeDiameter = 12.250;
        this.wellGeometry.jointLength = null;
        this.wellGeometry.modulusOfElasticity = 30000000;
        this.wellGeometry.axialTensionLoad = null;
        this.wellGeometry.inclinationAngle = null;
        this.wellGeometry.tailSlurryDensity = null;
        this.wellGeometry.mudDensity = null;

        this.subscription = this.sharedSettingsService.settings$.subscribe(settings => {
            if (settings.casingOD !== null) {
                this.wellGeometry.casingOD = settings.casingOD;
            }
            if (settings.holeDiameter !== null) {
                this.wellGeometry.holeDiameter = settings.holeDiameter;
            }
        });

        this.setSharedSettings();
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    onValueChange(): void {
        const results = this.standOffService.calculate(this.wellGeometry);
        this.setResult(results);
        this.setSharedSettings();
    }

    setResult(results: { atMiddlePoint?: AtMiddlePoint | null; atCentralizers?: AtCentralizers | null; lateralLoadResults?: LateralLoadResults | null }): void {
        this.atMiddlePoint.inches = results.atMiddlePoint?.inches ?? null;
        this.atMiddlePoint.percentage = results.atMiddlePoint?.percentage ?? null;

        this.atCentralizers.inches = results.atCentralizers?.inches ?? null;
        this.atCentralizers.percentage = results.atCentralizers?.percentage ?? null;

        this.lateralLoadResults.onCentralizers = results.lateralLoadResults?.onCentralizers ?? null;
        this.lateralLoadResults.onSpan = results.lateralLoadResults?.onSpan ?? null;
    }

    setSharedSettings(): void {
        this.sharedSettingsService.setSharedSetting({
            casingOD: this.wellGeometry.casingOD ?? null,
            holeDiameter: this.wellGeometry.holeDiameter ?? null,
            standOffOverride: this.atMiddlePoint.percentage ?? null
        });
    }

    hasValue(value: number | null | undefined): boolean {
        return value !== null && value !== undefined && value.toString() !== '';
    }

    get allInputsFilled(): boolean {
        const wg = this.wellGeometry;
        return this.hasValue(wg.casingWeight) &&
               this.hasValue(wg.casingOD) &&
               this.hasValue(wg.casingID) &&
               this.hasValue(wg.connectionOD) &&
               this.hasValue(wg.holeDiameter) &&
               this.hasValue(wg.jointLength) &&
               this.hasValue(wg.modulusOfElasticity) &&
               this.hasValue(wg.axialTensionLoad) &&
               this.hasValue(wg.inclinationAngle) &&
               this.hasValue(wg.tailSlurryDensity) &&
               this.hasValue(wg.mudDensity);
    }
}